import { StrapiData } from '@utilities/strapi/types'

const STATUS = {
  WON: 'won',
  WINNING: 'winning',
  OUTBID: 'outbid',
  LOST: 'lost',
  SOLD: 'sold',
  CLOSED: 'closed',
}

const DISTANCES = [
  { label: '1 Miles', value: 1 },
  { label: '2 Miles', value: 2 },
  { label: '5 Miles', value: 5 },
  { label: '10 Miles', value: 10 },
  { label: '15 Miles', value: 15 },
  { label: '20 Miles', value: 20 },
  { label: '25 Miles', value: 25 },
  { label: '50 Miles', value: 50 },
  { label: '100 Miles', value: 100 },
  { label: 'Any Distance', value: Infinity },
]

const STATE_ABBREVIATIONS = {
  AL: 'Alabama',
  KY: 'Kentucky',
  OH: 'Ohio',
  AK: 'Alaska',
  LA: 'Louisiana',
  OK: 'Oklahoma',
  AZ: 'Arizona',
  ME: 'Maine',
  OR: 'Oregon',
  AR: 'Arkansas',
  MD: 'Maryland',
  PA: 'Pennsylvania',
  MA: 'Massachusetts',
  CA: 'California',
  MI: 'Michigan',
  RI: 'Rhode Island',
  CO: 'Colorado',
  MN: 'Minnesota',
  SC: 'South Carolina',
  CT: 'Connecticut',
  MS: 'Mississippi',
  SD: 'South Dakota',
  DE: 'Delaware',
  MO: 'Missouri',
  TN: 'Tennessee',
  DC: 'District of Columbia',
  MT: 'Montana',
  TX: 'Texas',
  FL: 'Florida',
  NE: 'Nebraska',
  GA: 'Georgia',
  NV: 'Nevada',
  UT: 'Utah',
  NH: 'New Hampshire',
  VT: 'Vermont',
  HI: 'Hawaii',
  NJ: 'New Jersey',
  VA: 'Virginia',
  ID: 'Idaho',
  NM: 'New Mexico',
  IL: 'Illinois',
  NY: 'New York',
  WA: 'Washington',
  IN: 'Indiana',
  NC: 'North Carolina',
  WV: 'West Virginia',
  IA: 'Iowa',
  ND: 'North Dakota',
  WI: 'Wisconsin',
  KS: 'Kansas',
  WY: 'Wyoming',
}

const SECOND = 1
const MINUTE = 60 * SECOND
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR

const TIME_UNITS = {
  SECOND,
  MINUTE,
  HOUR,
  DAY,
}

const DEFAULT_CATEGORY_LIST = [
  {
    name: 'Retail Inventory',
    img: 'https://bidfta-files.s3.amazonaws.com/shutterstock_1067724467_2bd80d982e.jpg?updated_at=2022-06-27T18:35:20.991Z',
    link: '/category/retail-inventory/1',
  },
  {
    name: 'Building Materials',
    img: '',
    link: '/category/building-materials/1',
  },
  {
    name: 'Food Service Equipment',
    img: '',
    link: '/category/top-shop-food-service-equipment/1',
  },
  { name: 'Truckloads', img: '', link: '/category/truckloads/1' },
  { name: 'BIDFTA + Auctions', img: '', link: '/category/members-only/1' },
  { name: 'Automotive', img: '', link: '/category/automotive/1' },
]

const CATEGORIES = {
  ON_SALE: 118,
}

const RETURN_POLICIES = {
  FIXED_PRICE: {
    notes: {
      id: 1844643,
      keyId: 6,
      auctionId: 309051,
      keyValue: "###Major Appliances:\n\n• If the appliance is not working, the customer can return it to the original store of purchase within three (3) business days. There will be a $35 restocking fee added to each item(s) over $150\n\n• After three (3) business days, returns are not accepted\n\n• Appliances listed As Is are not eligible for returns\n\n• Returns will not be accepted for damage that occurs during customer transport or installation\n\n###General Merchandise:\n\n• General merchandise items are sold as-is. No refunds, returns, or exchanges will be issued",
      keyName: "Fixed Price Finds Return Policy",
      ordinal: 6,
      keyFor: "note"
    }
  },
}

const MEMBERS_ONLY_TYPE_ID = 2

const USER_DETAILS = {
  isSubscribed: false,
  bidsItemIds: [],
  watchlistItemIds: [],
  dashboardCounts: {
    invoices: 0,
    notifications: 0,
    receipts: 0,
    bids: 0,
    winningBids: 0,
    watchlist: 0,
    winningWatchList: 0,
    losingWatchlist: 0,
    winningBidTotal: 0,
    cards: 0,
  },
  profile: {
    address: '',
    bcCustomerId: null,
    city: '',
    company: '',
    customerId: '',
    dateofBirth: null,
    email: '',
    emailNotification: false,
    emailVerificationStatus: false,
    firstName: '',
    id: null,
    isAddedCard: false,
    lastName: '',
    offer: false,
    payment: false,
    phone1: '',
    phone2: '',
    savedSearch: false,
    smsNotification: false,
    smsNumber: '',
    smsVerificationStatus: false,
    state: '',
    unit: '',
    zip: '',
  },
}

const FEEDBACK = {
  title: '',
  message: '',
  color: '',
}

const LOCATION = {
  id: null,
  nickName: '',
  address: '',
  city: '',
  state: '',
  zip: '',
  contactPhone: '',
  contactEmail: '',
  hours: '',
  map: '',
  taxRate: null,
  enabled: null,
}

const EMPTY = { USER_DETAILS, FEEDBACK, LOCATION }

const COOKIES = {
  EXPIRATION: 30 * DAY,
}

const HOMEPAGE: StrapiData = {
  title: 'BIDFTA ONLINE AUCTIONS',
  description: {
    compiledSource:
      '/*@jsxRuntime automatic @jsxImportSource react*/\nconst {jsxDEV: _jsxDEV} = arguments[0];\nconst {useMDXComponents: _provideComponents} = arguments[0];\nfunction _createMdxContent(props) {\n  const _components = Object.assign({\n    p: "p"\n  }, _provideComponents(), props.components);\n  return _jsxDEV(_components.p, {\n    children: "BidFTA Online Auctions offers the most thrilling way to buy customer returns and overstock items at up to 90% off of retail prices.  We auction everything from furniture, home improvement, electronics, baby products, and so much more!"\n  }, undefined, false, {\n    fileName: "<source.js>",\n    lineNumber: 1,\n    columnNumber: 1\n  }, this);\n}\nfunction MDXContent(props = {}) {\n  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);\n  return MDXLayout ? _jsxDEV(MDXLayout, Object.assign({}, props, {\n    children: _jsxDEV(_createMdxContent, props, undefined, false, {\n      fileName: "<source.js>"\n    }, this)\n  }), undefined, false, {\n    fileName: "<source.js>"\n  }, this) : _createMdxContent(props);\n}\nreturn {\n  default: MDXContent\n};\n',
    frontmatter: {},
    scope: {},
  },
  explanationTitle: 'WHAT IS AN ONLINE AUCTION',
  explanationDescription: {
    compiledSource:
      '/*@jsxRuntime automatic @jsxImportSource react*/\nconst {Fragment: _Fragment, jsxDEV: _jsxDEV} = arguments[0];\nconst {useMDXComponents: _provideComponents} = arguments[0];\nfunction _createMdxContent(props) {\n  const _components = Object.assign({\n    p: "p"\n  }, _provideComponents(), props.components);\n  return _jsxDEV(_Fragment, {\n    children: [_jsxDEV(_components.p, {\n      children: "Discover Unbeatable Deals with Our Online Auctions"\n    }, undefined, false, {\n      fileName: "<source.js>",\n      lineNumber: 1,\n      columnNumber: 1\n    }, this), "\\n", _jsxDEV(_components.p, {\n      children: "An online auction is a dynamic marketplace where you can secure the best items from top retailers at prices that are significantly lower—often up to 90% off retail price. It\'s a new way to shop, offering not just substantial savings but also the excitement of winning."\n    }, undefined, false, {\n      fileName: "<source.js>",\n      lineNumber: 3,\n      columnNumber: 1\n    }, this), "\\n", _jsxDEV(_components.p, {\n      children: "How It Works"\n    }, undefined, false, {\n      fileName: "<source.js>",\n      lineNumber: 5,\n      columnNumber: 1\n    }, this), "\\n", _jsxDEV(_components.p, {\n      children: "Every auction is conducted online, allowing you to participate from the comfort of your home or on the go. Each item is linked to a physical location for convenient pickup after the auction concludes. Whether you\'re looking for electronics, furniture, or rare collectibles, our online auctions provide a transparent, user-friendly platform for securing the best deals."\n    }, undefined, false, {\n      fileName: "<source.js>",\n      lineNumber: 7,\n      columnNumber: 1\n    }, this), "\\n", _jsxDEV(_components.p, {\n      children: "Getting Started Is Easy"\n    }, undefined, false, {\n      fileName: "<source.js>",\n      lineNumber: 9,\n      columnNumber: 1\n    }, this), "\\n", _jsxDEV(_components.p, {\n      children: "New to online auctions? No problem! Our introductory guide walks you through your first steps, ensuring you\'re equipped to start bidding and winning. Learn how to set up your account, place bids, and understand auction terms and conditions for a seamless experience."\n    }, undefined, false, {\n      fileName: "<source.js>",\n      lineNumber: 11,\n      columnNumber: 1\n    }, this), "\\n", _jsxDEV(_components.p, {\n      children: "Dive into the world of online auctions with us and unlock major savings on premium items. Get started by registering today!"\n    }, undefined, false, {\n      fileName: "<source.js>",\n      lineNumber: 13,\n      columnNumber: 1\n    }, this)]\n  }, undefined, true, {\n    fileName: "<source.js>",\n    lineNumber: 1,\n    columnNumber: 1\n  }, this);\n}\nfunction MDXContent(props = {}) {\n  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);\n  return MDXLayout ? _jsxDEV(MDXLayout, Object.assign({}, props, {\n    children: _jsxDEV(_createMdxContent, props, undefined, false, {\n      fileName: "<source.js>"\n    }, this)\n  }), undefined, false, {\n    fileName: "<source.js>"\n  }, this) : _createMdxContent(props);\n}\nreturn {\n  default: MDXContent\n};\n',
    frontmatter: {},
    scope: {},
  },
  socialProofTitle: 'SEE WHAT OUR CUSTOMERS SAY ABOUT BIDFTA',
  createdAt: '2024-03-13T15:43:36.834Z',
  updatedAt: '2024-03-13T15:47:00.379Z',
  publishedAt: '2024-03-13T15:43:39.107Z',
  feedback: [],
}

const SLOGAN = {
  part1: 'Turn your wants into wins with',
  part2: 'BidFTA Online Auctions',
}

const STRAPI = { HOMEPAGE, SLOGAN }

const DEFAULT = {
  PAGINATION: {
    PAGE_NUMBER_SHOWING: 4,
  },
  STRAPI,
}

const LINKS = {
  AUCTION_FAQ: `/faq`,
  CAREERS:
    'https://recruiting.paylocity.com/recruiting/jobs/All/610350af-7764-44c1-b57e-648e74c516ce/2MC-Employee-Management',
  HOW_TO_PICKUP_ITEMS:
    'https://wefasttrackit.zendesk.com/hc/en-us/categories/360000894272-Picking-Up-an-Item',
  BIDFTA_PLUS: '/bidfta-plus',
  DIY_AUCTIONS: '/category/diy-auctions/1',
  LEARN_ABOUT_DIY: 'https://shop.bidfta.com/diy-auctions/',
  SELL_WITH_US:
    'https://wefasttrackit.zendesk.com/hc/en-us/articles/115001861806-How-to-Sell-with-BidFTA-com-',
  AUCTION_CONTACT: 'https://wefasttrackit.zendesk.com/hc/en-us/requests/new',
  TERM_AND_CONDITIONS: '/terms',
  PRIVACY_POLICY: '/privacy-policy',
}

const TOKEN = {
  NAME: 'next-auth-account',
  EMPTY: {
    accessToken: null,
    refreshToken: null,
    tokenType: null,
    expiryDuration: null,
    expirationDateTime: null,
    refreshTokenExpiryDuration: null,
    refreshTokenExpirationDateTime: null,
  },
} as const

const C = {
  STATUS,
  DISTANCES,
  TIME_UNITS,
  DEFAULT_CATEGORY_LIST,
  CATEGORIES,
  MEMBERS_ONLY_TYPE_ID,
  STATE_ABBREVIATIONS,
  EMPTY,
  COOKIES,
  DEFAULT,
  LINKS,
  TOKEN,
  RETURN_POLICIES,
}

export default C
